<script>
  import { keyFilms, serveurFilm } from "../conf.js";
  import { onMount } from "svelte";
  import { pop, location, push } from "svelte-spa-router";

  let leFilm = null;
  let idFilm = 0;
  let FilmsSimilaires = [];
  export let params = {};

  /**
   * recupere le parazm passer via l url
   */
  const getID = () => {
    return params.id;
  };

  /**
   * selection un sule films pour le detail
   */
  const chercherOneFilm = async (idArg = null) => {
    if (idArg == null) {
      idFilm = getID();
    } else {
      idFilm = idArg;
    }

    //console.log("id-one = " + idFilm);
    if (idFilm != 0) {
      const response = await fetch(
        serveurFilm + "movie/" + idFilm + "?language=fr-FR&api_key=" + keyFilms
      );
      if (response.ok) {
        const result = await response.json();
        //console.log(result);
        return result;
      } else {
        throw new (error(text))();
      }
    } else {
      return null;
    }
  };

  /**
   *
   */
  const filmsSimilar = async () => {
    if (idFilm != 0) {
      const urlStr =
        serveurFilm +
        "movie/" +
        idFilm +
        "/similar?language=fr-FR&api_key=" +
        keyFilms +
        "&sort_by=vote_count.desc";

      console.log("Similar = " + urlStr);

      const response = await fetch(urlStr);

      if (response.ok) {
        const result = await response.json();
        console.log(result);
        FilmsSimilaires = result.results;
      } else {
        throw new (error(text))();
      }
    }
  };

  /**
   * Grosse bidouille pour charger un film different sur la meme page
   * @param id
   */
  const goTo = async (id) => {
    //console.log("goTO = " + id);
    //push("/film/" + id);
    leFilm = await chercherOneFilm(id);
  };

  onMount(async () => {
    leFilm = await chercherOneFilm();
  });
</script>

{#await leFilm}
  Wait ....
{:then leFilm}
  {#if leFilm}
    <button on:click={() => pop()}>back</button>
    <div class="card" style="max-width: 640px;">
      <div class="row g-0">
        <div class="col-3">
          <img
            src="https://image.tmdb.org/t/p/w92/{leFilm.poster_path}"
            alt="..."
          />
        </div>
        <div class="col-8">
          <div class="card-body">
            <h5 class="card-title">{leFilm.original_title}</h5>
            <p class="card-text">
              <strong>Année :</strong>
              <span class="card-rep">{leFilm.release_date}</span>
            </p>
            <p class="card-text">
              <strong>Populatité :</strong>
              <span class="card-rep">{leFilm.populatiry}</span>
            </p>
            <p class="card-text">
              <strong>Vote (av):</strong>
              <span class="card-rep"
                >{leFilm.vote_average} - Vote :
                <span class="card-rep">{leFilm.vote_count}</span></span
              >
            </p>
          </div>
        </div>
        <div class="col-12">
          <div class="card-body">
            <p class="card-text">
              {leFilm.overview}
            </p>
          </div>
          <button class="btn btn-info btn-sm" on:click={filmsSimilar}
            >Similaire ({leFilm.id})</button
          >
        </div>
      </div>
    </div>
    <hr />
    <table class="table card-body table-sm">
      <tr>
        <td>titre</td>
        <td>vote</td>
        <td>moyenne</td>
        <td />
      </tr>
      <tbody>
        {#each FilmsSimilaires as item}
          <tr>
            <td>{item.original_title} - ({item.release_date.substr(0, 4)})</td>
            <td>{item.count}</td>
            <td
              class={item.vote_count > 2000 && item.vote_average > 7.5
                ? "good"
                : ""}>{item.vote_average}</td
            >
            <td>
              <button
                on:click|preventDefault={goTo(item.id)}
                class="btn btn-primary">X</button
              ></td
            >
          </tr>
        {/each}
      </tbody>
    </table>
  {/if}
{/await}

<style>
  .card-body {
    font-size: 0.85em;
  }

  .card-rep {
    color: rgb(150, 19, 91);
  }
  .good {
    color: red;
  }
</style>
